import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Box, Button, Flex, Image, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { selectProcoreSidePanelData } from '../../../redux/modules/procoreSidePanel';
import underConstructionImage from '../../../under-construction.png';
import ProjectRecordsSidePanel from '../ProjectRecordsSidePanel';

const ProjectRecordsLanding = props => {
  const history = useHistory();
  const {
    procoreUser,
    pinsAccessToken,
    procoreAccessToken,
    procoreCompanyId,
    procoreProjectId
  } = useSelector(selectProcoreSidePanelData);

  if (!procoreUser || !procoreAccessToken || !pinsAccessToken) {
    return (
      <Box
        bg="background.main"
        height="100%"
        minHeight="100vh"
        padding={4}
      >
        <Flex
          alignItems="center"
          flexDirection="column"
          height="100%"
          justifyContent="center"
          my={8}
          py={4}
        >
          <Image mb={8} src={underConstructionImage} />
          <Text my={2}>Looks like you have not authenticated yet.  Click the button below to authenticate with Procore.</Text>
          <Button onClick={() => history.replace('landing')}>
            Restart Authentication
          </Button>
        </Flex>
      </Box>
    );
  }

  if (PINS_ENV === 'prod' && !procoreUser.isEmployee) {
    return (
      <Box
        bg="background.main"
        height="100%"
        minHeight="100vh"
        padding={4}
      >
        <Flex
          alignItems="center"
          flexDirection="column"
          height="100%"
          justifyContent="center"
          my={8}
          py={4}
        >
          <Image mb={8} src={underConstructionImage} />
          <Text my={2}>Looks like you are not an employee of this Procore company.</Text>
          <Text mb={2}>The PINS Side Panel App is currently only available to employees.</Text>
          <Text mb={2}>If you believe this is an error, please contact your Procore admin.</Text>
          <Button onClick={() => history.replace('landing')}>
            Restart Authentication
          </Button>
        </Flex>
      </Box>
    );
  }

  return (
    <ProjectRecordsSidePanel
      procoreCompanyId={procoreCompanyId}
      procoreProjectId={procoreProjectId}
    />
  );
};

ProjectRecordsLanding.propTypes = {};

export default ProjectRecordsLanding;
